import * as angular from 'angular';
import {IController} from "angular";
import {ServiceItem} from "../../models/service-item.model";
import * as _ from "lodash";
import {MissingItemDataModel, MissingItemModel} from "../../../deliveries/models/missing-item.model";
import {PackageDetailsViewSettingsService} from "../../services/package-details-view-settings.service";


export class ServiceItemsTableComponent implements IController {

  query?: string;
  items: ServiceItem[];
  missingItems?: MissingItemModel[];
  isShowAttachments: boolean;
  settings: any;
  enableEditMissingItems?: boolean;
  onMissingItemsChange: Function;
  onEdit: Function;

  public viewItems: any;
  public isScrollable: boolean;
  public columns: any;
  public packageDynamicColumns: any;
  public isShowSettingsButton: boolean;
  public missingItemsAttachmentsMap: any;

  private isViewSettingsChanged = false;

  constructor(private $mdMedia, private $element,
              private packageDetailsViewSettingsService: PackageDetailsViewSettingsService) {
  }

  $onInit() {
    this.columns = this.settings.columns;
    this.packageDynamicColumns = this.settings.packageDynamicColumns;
    this._setViewItems();

    this.packageDetailsViewSettingsService.load()
      .then((columnsMap) => {
        if (this.isViewSettingsChanged) {
          return;
        }
        const viewColumns = this.packageDetailsViewSettingsService.applyColumnsMap(columnsMap, this.columns, this.packageDynamicColumns);
        this.settings = {...this.settings, ...viewColumns};
        this.columns = viewColumns.columns;
        this.packageDynamicColumns = viewColumns.packageDynamicColumns;
      });
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (
      changes.items && !changes.items.isFirstChange() ||
      changes.missingItems && !changes.missingItems.isFirstChange()
    ) {
      this._setViewItems();
    }
  }

  $doCheck() {
    const numOfColumns = _.reduce(this.columns, (sum, column) => {
      return sum += column.enabled ? 1 : 0;
    }, 0);
    this.isScrollable = numOfColumns > 5 || _.isUndefined(this.columns) ? true : !this.$mdMedia('gt-md');
  }

  setEvents() {
    const div1 = this.$element[0].querySelector('#header')
    const div2 = document.getElementById('services-items-table-container');

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }

  onViewSettingsChange(settings) {
    this.isViewSettingsChanged = true;
    // Reset emits no packageDynamicColumns - fall back to the site default (all hidden).
    settings.packageDynamicColumns = settings.packageDynamicColumns ?? _.map(this.packageDynamicColumns, c => ({...c, enabled: false}));
    this.settings = settings;
    this.columns = this.settings.columns;
    this.packageDynamicColumns = this.settings.packageDynamicColumns;
    this.packageDetailsViewSettingsService.save(this.packageDetailsViewSettingsService.toColumnsMap(this.columns, this.packageDynamicColumns));
  }

  private _setViewItems() {
    let viewItems = [];
    const serviceItems = this.items || [];
    const missingItems = this.missingItems || [];

    // Set View Items - Service Items + Missing Items Rows.
    serviceItems.forEach((item) => {
      viewItems.push(item);

      if (item.missingItems?.length) {
        viewItems = viewItems.concat(item.missingItems)
      }
    })

    this.viewItems = viewItems;
    this.missingItemsAttachmentsMap = this._getMissingItemsAttachmentsMap(viewItems);
  }

  private _getMissingItemsAttachmentsMap(items) {
    const missingItems: MissingItemDataModel[] = _.compact(_.flatMap(items, 'missingItems'));
    return _.mapValues(
      _.keyBy(missingItems, 'reasonId'),
      item => _.flatMap(item.actions || [], action =>
        action.attachments || []
      )
    );
  }


}

angular
  .module('bringoz.admin.commons')
  .component('serviceItemsTable', {
    bindings: {
      query: '<?',
      items: '<',
      missingItems: '<?',
      settings: '<',
      enableEditMissingItems: '<?',
      onMissingItemsChange: '&',
      onEdit: '&'
    },
    template: require('./service-items-table.html').default,
    controller: ServiceItemsTableComponent
  });
